// Lokaler Stand fuer Event-Erinnerungen (Popup "Morgen findet ... statt"). Speicherung bleibt in den Apps.

export const MAX_STORED_REMINDER_KEYS = 50;

/** Ein Event-Termin wird nur einmal angezeigt; eine Verschiebung erzeugt einen neuen Schluessel. */
export function getReminderKey(reminder: { eventId: string; startDate: number }): string {
  return `${reminder.eventId}:${reminder.startDate}`;
}

/** Erste Erinnerung, die noch nicht geschlossen wurde. */
export function pickNextReminder<T extends { eventId: string; startDate: number }>(
  reminders: readonly T[] | null | undefined,
  dismissedKeys: readonly string[],
): T | null {
  if (!reminders) return null;
  return reminders.find((reminder) => !dismissedKeys.includes(getReminderKey(reminder))) ?? null;
}

/** Fuegt den Schluessel ans Ende an (ohne Duplikat) und behaelt nur die neuesten Eintraege. */
export function appendDismissedReminderKey(
  keys: readonly string[],
  key: string,
  maxKeys: number = MAX_STORED_REMINDER_KEYS,
): string[] {
  return [...keys.filter((existing) => existing !== key), key].slice(-maxKeys);
}

/** Liest gespeicherte Schluessel; akzeptiert ein Array oder { dismissedReminderKeys }. */
export function parseDismissedReminderKeys(value: unknown): string[] {
  const candidate =
    value && typeof value === 'object' && !Array.isArray(value)
      ? (value as { dismissedReminderKeys?: unknown }).dismissedReminderKeys
      : value;
  return Array.isArray(candidate) ? candidate.filter((key): key is string => typeof key === 'string') : [];
}
